import { InMemoryObjectBase } from '../../../helpers/in-memory-object';
import { JSONUtilites } from '../../../helpers/JSONUtilites';
import { ProductPricelist } from './product-pricelist';

export class InMemoryProductPricelists extends InMemoryObjectBase<ProductPricelist> {

  protected get storeKeyName(): string {
    return 'in_memory_product_pricelists';
  }

  protected _createDemoItems(): ProductPricelist[] {
    const item1 = {
      id: 1,
      name : 'Public Pricelist',
      pricelistVersions : [{
        id: 1,
        name: 'Default Public Pricelist Version',
        dateStart: null,
        dateEnd: null,
        productPricelistItems: [{
          id : 1,
          name : 'Default Public Pricelist Line',
          categId : null,
          minQuantity : 0,
          priceDiscount : 0,
          priceMaxMargin : null,
          priceMinMargin : null,
          priceRound : null,
          priceSurcharge : 0,
          productId : null,
          productTmplId : null,
          sequence : null,
        },
        {
          id : 2,
          name : 'Default Public Pricelist Line',
          categId : null,
          minQuantity : 0,
          priceDiscount : 0,
          priceMaxMargin : null,
          priceMinMargin : null,
          priceRound : null,
          priceSurcharge : 0,
          productId : null,
          productTmplId : null,
          sequence : null,
        }],
      }],
    };
    return [ProductPricelist.createFromAny(item1)];
  }

  protected _FromJSON(json: string): ProductPricelist[] {
    return JSONUtilites.arrayFromJSON<ProductPricelist>(null, json, ProductPricelist.createFromAny);
  }
}

